import { render, staticRenderFns } from "./serviceTypelibrary.vue?vue&type=template&id=70cf721e"
import script from "./serviceTypelibrary.vue?vue&type=script&lang=js"
export * from "./serviceTypelibrary.vue?vue&type=script&lang=js"
import style0 from "./serviceTypelibrary.vue?vue&type=style&index=0&id=70cf721e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports